<style lang="scss" src='./AlertsDetails.scss' scoped></style>
<template src="./AlertsDetails.html"></template>

<script>
import { mapMutations, mapState } from "vuex";
import AlertGraph from '@/components/alertGraph/AlertGraph.vue';
import GwRing from '@/components/gwRing/GwRing.vue';

import CommonComponent from "@/components/utils/CommonComponent.vue";
import { GetSensorRingGraph } from '@/api/api';

export default {
  name: "AlertsDetails",
  extends: CommonComponent,
  props: {},
  data() {
    return {
      ico_measurement: null,
      ringData: null,
    };
  },
  components: {
    AlertGraph,
    GwRing,
  },
  watch: {},

  computed: {
    ...mapState(["course", "alert", "user"]),
    ...mapState('SensorList', {
      rssiRanges: (state) => state.rssiRanges,
    }),
    ...mapState(['course']), 

    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },
    //...mapState("sensors", ["showAlertList", "ringsData"]),
    getRingData() {
      if (this.consts.AlertType[this.alert.alert_type.alert_type_id].key == this.consts.AlertType['SENSOR_TRANSITION'].key) {
        return this.ringData[this.consts.AlertType['MOISTURE'].key]
      }
      return this.ringData[this.consts.AlertType[this.alert.alert_type.alert_type_id].key]
    },
  },

  methods: {
    getRssiIcon() {
      // eslint-disable-next-line
      return require(`@/assets/img/gw/sensor/${this.G_getRssiIcon(this.alert.sensor, this.rssiRanges)}`);
    },

    showAlertDetails() {
      this.setShowAlertList(true);
    },

    getThresholdViolation(alert) {
      let valueViolation = null;
      if (alert.sensor) {
        let minMax = "min_";
        const alertType = this.consts.AlertType[alert.alert_type_id];
        if (alert.violation === "READING_HIGH") {
          minMax = "max_";
        }

        let alertKey = alertType.key;
        if(alert.is_night_time && alert.alert_type_id == 'GROUND_TEMPERATURE'){
          alertKey = 'night_temp'
        }

        valueViolation = alert.sensor.threshold[minMax + alertKey];
      } else {
        const threshold = alert.station.thresholds.find(
          (t) => t.alert_type_id === alert.alert_type_id
        );
        if (threshold) {
          valueViolation =
            alert.violation === "READING_HIGH" ? threshold.max : threshold.min;
        }
      }

      if (valueViolation != null) {
        return this.G_getMeasurement({
          val: valueViolation,
          uom: alert.alert_type.uom,
          addUnit: true,
          invertUOM: false,
        });
      }

      return "";
    },

    async setIcoMeasurement() {
      const alertKey = this.consts.AlertType[
        this.alert.alert_type.alert_type_id
      ].id;
      this.ico_measurement = await require(`@/assets/img/gw/alert/${alertKey}_fill.png`);
    },

    async loadSensorRingGraph() {
      const ringsDataReponse = await GetSensorRingGraph(this.alert.sensor.sensor_id);
      this.ringData = ringsDataReponse ? this.G_getSensorRingsData(ringsDataReponse.data) : {};
    },

    setTask(){
      const task = this.G_createTaskFromAlert(this.alert);
      this.setTaskAlert(task)
    },

    ...mapMutations(['setTaskAlert']),
  },

  beforeCreate() {},

  created() {},

  beforeMount() {
    this.setShowMenu(false);
    this.setShowBackground(false);
  },

  mounted() {
    this.setIcoMeasurement();
    this.setTask();

    this.ringData = {}

    if(this.alert.sensor){
      this.loadSensorRingGraph()
    }else{
      if(this.alert.alert_type_id != 'WS_CONNECTION_FAILURE'){
        const threshold = this.alert.station.thresholds.find(t => t.alert_type_id === this.alert.alert_type_id);
        const unitOfMeasurament = this.G_getUOM({
              uom: threshold.alert_type.uom
        });

        const current = this.G_getMeasurement({ val: this.alert.reading, uom: threshold.alert_type.uom });
        const maxTh = threshold.max ? this.G_getMeasurement({ val: threshold.max, uom: threshold.alert_type.uom }): null;
        const maxVal = threshold.alert_type.max ? this.G_getMeasurement({ val: threshold.alert_type.max, uom: threshold.alert_type.uom }): null;
        const minTh = threshold.min ? this.G_getMeasurement({ val: threshold.min, uom: threshold.alert_type.uom }): null;
        const minVal = threshold.alert_type.min ? this.G_getMeasurement({ val: threshold.alert_type.min, uom: threshold.alert_type.uom }): null;
    
        let data = {
          alert: true,
          currentValue: parseFloat(current),
          key: this.alert.alert_type_id,
          maxThreshold: maxTh,
          maxValue: maxVal,
          minThreshold: minTh,
          minValue: minVal,
          unit: unitOfMeasurament
        }
    
        this.ringData = data
      }
    }
  },
};
</script>
